<template>
    <div>
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="订单状态：" class="query-form-item">
                <el-select v-model="query.status" placeholder="状态" style="width: 120px"  @change="change">
                    <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :height="tableHeight"
            :data="list"
            size="mini"
            stripe border style="width: 100%">
            <el-table-column
                min-width="164"
                label="编号">
                <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="用户id"
                width="170">
                <template slot-scope="scope">
                    <span>{{ scope.row.admin_id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                min-width="200"
                label="用户名称">
                <template slot-scope="scope">
                    <span>{{ scope.row.username }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="联系方式"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.contact }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="金额"
                align="center"
                width="90">
                <template slot-scope="scope">
                    <span>{{ scope.row.amount }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="货币"
                width="100"
                align="center">
                <template slot-scope="scope">
                    <el-tag type="danger">人民币</el-tag>
                    <!-- <el-tag v-if="scope.row.currency == 'CNY'">人民币</el-tag>
                    <el-tag v-if="scope.row.currency == 'USD'">美金</el-tag> -->
                </template>
            </el-table-column>
            <el-table-column
                label="状态"
                width="100"
                align="center">
                <template slot-scope="scope">
                    <el-tag type="warning" v-if="scope.row.status == 0">未处理</el-tag>
                    <el-tag v-if="scope.row.status == 1">已处理</el-tag>
                    <el-tag type="danger" v-if="scope.row.status == 2">已取消</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="时间"
                align="center"
                width="200">
                <template slot-scope="scope">
                    <span>{{ scope.row.time }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                fixed="right"
                width="160">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.status == 0" style="margin: 0 0 10px 10px" type="primary" size="mini" @click.native="topups(scope.row)" :disabled="disabled">充值</el-button>
                    <!-- <el-button v-if="scope.row.status == 0" style="margin: 0 0 10px 10px" type="danger" size="mini" @click.native="cancel(scope.row)" :disabled="disabled">取消</el-button> -->
                    <el-popover
                    v-if="scope.row.status == 1"
                        placement="right" title
                        trigger="click">
                        <div style="width:300px;">
                            <img
                                style="width:100%;"
                                :src="img"
                                alt
                            />
                        </div>
                        <el-button v-if="scope.row.amount != '0.00'" slot="reference" style="margin: 0 0 10px 10px" type="primary" size="mini" :disabled="disabled" @click.native="viewVoucher(scope.row)">查看充值凭证</el-button>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;margin-top: 20px; margin-bottom: 22px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="query.total">
        </el-pagination>
        <add :visible="ctrl.addDialogVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback"></add>
    </div>
</template>

<script>
import * as api from "@/api/user/payorders";
import Add from "./add";
export default {
    components: { Add },
    data() {
        return {
            tableHeight: null,
            list: [],
            disabled: false,
            ctrl: {
                addDialogVisible: false
            },
            query: {
                page: 1,
                limit: 20,
                status: "0"
            },
            formData: {
                images: ""
            },
            loading: false,
            filter: {},
            img: "",
            roles: [
                {
                    id: "0",
                    name: "未处理"
                },
                {
                    id: "1",
                    name: "已处理"
                }
                // {
                //     id: "2",
                //     name: "已取消"
                // }
            ]
        };
    },
    methods: {
        getList() {
            let obj = this.query;
            api.admin_request_list(obj).then(res => {
                if (res.code === 0) {
                    this.list = res.data.list;
                    this.query.page = res.data.page;
                    this.query.total = res.data.total;
                    this.query.total_page = res.data.total_page;
                } else {
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        //充值
        topups(data) {
            this.disabled = true;
            api.evidence_image({ id: data.evidence_id })
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        this.formData = JSON.parse(JSON.stringify(data));
                        this.$set(this.formData, "image", res.data.img);
                        this.ctrl.dialogTitle = data.username + " 充值";
                        this.ctrl.addDialogVisible = true;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        //查看凭证
        viewVoucher(data) {
            this.img = "";
            api.evidence_image({ id: data.evidence_id })
                .then(res => {
                    if (res.code === 0) {
                        // 提交成功, 跳转页面
                        this.img = res.data.img;
                        this.disabled = false;
                    } else {
                        this.disabled = false;
                        this.$message({
                            type: "error",
                            message: "提交失败  " + res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        //取消
        // cancel(data) {
        //     this.$confirm(`确定要取消 ${data.username} 的订单吗?`, {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning"
        //     })
        //         .then(() => {
        //             let obj = {};
        //             obj.id = data.id;
        //             obj.status = "2";
        //             this.disabled = true;
        //             api.proceed_charge_request(obj)
        //                 .then(res => {
        //                     if (res.code === 0) {
        //                         // 提交成功, 跳转页面
        //                         this.$message({
        //                             message: "取消成功",
        //                             type: "success"
        //                         });
        //                         this.disabled = false;
        //                         this.getList();
        //                     } else {
        //                         this.disabled = false;
        //                         this.$message({
        //                             type: "error",
        //                             message: "提交失败  " + res.message
        //                         });
        //                     }
        //                 })
        //                 .catch(() => {
        //                     this.disabled = false;
        //                 });
        //         })
        //         .catch(() => {});
        // },
        //筛选
        change(val) {
            this.filter.status = val;
            this.query.page = 1;
            this.getList();
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback() {
            this.ctrl.addDialogVisible = false;
            this.getList();
        }
    },
    created() {
        if (this.$route.query.status) {
            let obj = {};
            obj.status = this.$route.query.status;
            this.filter = obj;
        }
        this.getList();
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 165 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        164 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
